import script from "./RecycleTimeSlots.vue?vue&type=script&setup=true&lang=js"
export * from "./RecycleTimeSlots.vue?vue&type=script&setup=true&lang=js"

import "./RecycleTimeSlots.vue?vue&type=style&index=0&id=6d115434&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d115434"]])

export default __exports__